/**
 * This file was generated by st-open-api
 */
import {ErrorHandler} from '../interface/i-$-open-api';
import {IAirTravelRequest} from '../interface/components/i-air-travel-request';
import {ICalculationRequest} from '../interface/components/i-calculation-request';
import {ICalculationResponse} from '../interface/components/i-calculation-response';
import {ICarRentalRequest} from '../interface/components/i-car-rental-request';
import {IChoiceValuesResponse} from '../interface/components/i-choice-values-response';
import {IDistanceCalculationRequest} from '../interface/components/i-distance-calculation-request';
import {IDistanceCalculationResponse} from '../interface/components/i-distance-calculation-response';
import {IEcotransitBatchPostResponse} from '../interface/components/i-ecotransit-batch-post-response';
import {IEcotransitBatchRequest} from '../interface/components/i-ecotransit-batch-request';
import {IEcotransitBatchStatusPathParameter} from '../interface/parameter/i-ecotransit-batch-status-path-parameter';
import {IEcotransitBatchStatusQueryParameter} from '../interface/parameter/i-ecotransit-batch-status-query-parameter';
import {IEcotransitBatchStatusResponse} from '../interface/components/i-ecotransit-batch-status-response';
import {IEcotransitCalculationRequest} from '../interface/components/i-ecotransit-calculation-request';
import {IEcotransitCalculationResponse} from '../interface/components/i-ecotransit-calculation-response';
import {IFormulaCalculationResponse} from '../interface/components/i-formula-calculation-response';
import {IGetChoiceValuesPathParameter} from '../interface/parameter/i-get-choice-values-path-parameter';
import {IGetChoiceValuesQueryParameter} from '../interface/parameter/i-get-choice-values-query-parameter';
import {IGreenGrpAddressableTelevisionRequest} from '../interface/components/i-green-grp-addressable-television-request';
import {IGreenGrpCinemaRequest} from '../interface/components/i-green-grp-cinema-request';
import {IGreenGrpDoohGrossContactsRequest} from '../interface/components/i-green-grp-dooh-gross-contacts-request';
import {IGreenGrpDoohScreensRequest} from '../interface/components/i-green-grp-dooh-screens-request';
import {IGreenGrpLinearTelevisionRequest} from '../interface/components/i-green-grp-linear-television-request';
import {IGreenGrpNewspaperRequest} from '../interface/components/i-green-grp-newspaper-request';
import {IGreenGrpOOHRequest} from '../interface/components/i-green-grp-o-o-h-request';
import {IGreenGrpOnlineAudioRequest} from '../interface/components/i-green-grp-online-audio-request';
import {IGreenGrpOnlineImageRequest} from '../interface/components/i-green-grp-online-image-request';
import {IGreenGrpOnlineSearchRequest} from '../interface/components/i-green-grp-online-search-request';
import {IGreenGrpOnlineVideoRequest} from '../interface/components/i-green-grp-online-video-request';
import {IGreenGrpPrintTotalWeightRequest} from '../interface/components/i-green-grp-print-total-weight-request';
import {IGreenGrpRadioRequest} from '../interface/components/i-green-grp-radio-request';
import {IGreenGrpSocialMediaOnlineImageRequest} from '../interface/components/i-green-grp-social-media-online-image-request';
import {IGreenGrpSocialMediaOnlineVideoRequest} from '../interface/components/i-green-grp-social-media-online-video-request';
import {IGreenGrpSupplementRequest} from '../interface/components/i-green-grp-supplement-request';
import {IHotelStayRequest} from '../interface/components/i-hotel-stay-request';
import {IPPPMaterialWeightBatchRequest} from '../interface/components/i-p-p-p-material-weight-batch-request';
import {IPPPMaterialWeightBatchResponse} from '../interface/components/i-p-p-p-material-weight-batch-response';
import {IPPPMaterialWeightRequest} from '../interface/components/i-p-p-p-material-weight-request';
import {IPPPPaperDimensionRequest} from '../interface/components/i-p-p-p-paper-dimension-request';
import {IRailTravelRequest} from '../interface/components/i-rail-travel-request';
import {IRoadTravelRequest} from '../interface/components/i-road-travel-request';
import {IRothoCalculationRequest} from '../interface/components/i-rotho-calculation-request';
import {IRothoCalculationResponse} from '../interface/components/i-rotho-calculation-response';
import {IVehicleFleetConsumptionRequest} from '../interface/components/i-vehicle-fleet-consumption-request';
import {IVehicleFleetDistanceRequest} from '../interface/components/i-vehicle-fleet-distance-request';
import {IWasteManagementRequest} from '../interface/components/i-waste-management-request';
import {RequestInterceptor} from '../interface/i-$-open-api';
import {ResponseInterceptor} from '../interface/i-$-open-api';
import {http} from '../function/http';
import {openApi} from '../function/open-api';

export class CalculationBaseService {

    airTravel = async (body: IAirTravelRequest, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IFormulaCalculationResponse> => {
    
        const response = await http({
                method: 'POST',
                url: `${openApi.endpointUrl}/calculation/v1/calculate/travel/air`,
                header: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    calculateDistance = async (body: IDistanceCalculationRequest, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IDistanceCalculationResponse> => {
    
        const response = await http({
                method: 'POST',
                url: `${openApi.endpointUrl}/calculation/v1/calculate/distance`,
                header: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    carRentalTravel = async (body: ICarRentalRequest, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IFormulaCalculationResponse> => {
    
        const response = await http({
                method: 'POST',
                url: `${openApi.endpointUrl}/calculation/v1/calculate/travel/car-rental`,
                header: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    ecotransitBatchCalculation = async (body: IEcotransitBatchRequest, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IEcotransitBatchPostResponse> => {
    
        const response = await http({
                method: 'POST',
                url: `${openApi.endpointUrl}/calculation/v1/calculate/logistics/ecotransit/batch`,
                header: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    ecotransitBatchStatus = async (pathParameter: IEcotransitBatchStatusPathParameter, queryParameter: IEcotransitBatchStatusQueryParameter, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IEcotransitBatchStatusResponse> => {
    
        const queryParam = [
            {name: 'cursor', value: queryParameter.cursor},
            {name: 'limit', value: queryParameter.limit},
        ];
    
        const pathParam = {
            'batchId': pathParameter.batchId,
        };
    
        const response = await http({
                method: 'GET',
                url: `${openApi.endpointUrl}/calculation/v1/calculate/logistics/ecotransit/batch/{batchId}`,
                queryParameter: queryParam,
                urlParameter: pathParam,
                header: {
                    Accept: 'application/json',
                },
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    ecotransitCalculation = async (body: IEcotransitCalculationRequest, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IEcotransitCalculationResponse> => {
    
        const response = await http({
                method: 'POST',
                url: `${openApi.endpointUrl}/calculation/v1/calculate/logistics/ecotransit`,
                header: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    getChoiceValues = async (pathParameter: IGetChoiceValuesPathParameter, queryParameter: IGetChoiceValuesQueryParameter, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IChoiceValuesResponse> => {
    
        const queryParam = [
            {name: 'cursor', value: queryParameter.cursor},
            {name: 'limit', value: queryParameter.limit},
        ];
    
        const pathParam = {
            'choiceSlug': pathParameter.choiceSlug,
        };
    
        const response = await http({
                method: 'GET',
                url: `${openApi.endpointUrl}/calculation/v1/choices/{choiceSlug}`,
                queryParameter: queryParam,
                urlParameter: pathParam,
                header: {
                    Accept: 'application/json',
                },
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    greenGrpAddressableTelevision = async (body: IGreenGrpAddressableTelevisionRequest, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IFormulaCalculationResponse> => {
    
        const response = await http({
                method: 'POST',
                url: `${openApi.endpointUrl}/calculation/v1/calculate/green-grp/addressable-television`,
                header: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    greenGrpCinema = async (body: IGreenGrpCinemaRequest, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IFormulaCalculationResponse> => {
    
        const response = await http({
                method: 'POST',
                url: `${openApi.endpointUrl}/calculation/v1/calculate/green-grp/cinema`,
                header: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    greenGrpDoohGrossContacts = async (body: IGreenGrpDoohGrossContactsRequest, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IFormulaCalculationResponse> => {
    
        const response = await http({
                method: 'POST',
                url: `${openApi.endpointUrl}/calculation/v1/calculate/green-grp/dooh-gross-contacts`,
                header: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    greenGrpDoohScreens = async (body: IGreenGrpDoohScreensRequest, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IFormulaCalculationResponse> => {
    
        const response = await http({
                method: 'POST',
                url: `${openApi.endpointUrl}/calculation/v1/calculate/green-grp/dooh-screens`,
                header: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    greenGrpLinearTelevision = async (body: IGreenGrpLinearTelevisionRequest, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IFormulaCalculationResponse> => {
    
        const response = await http({
                method: 'POST',
                url: `${openApi.endpointUrl}/calculation/v1/calculate/green-grp/linear-television`,
                header: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    greenGrpNewspaper = async (body: IGreenGrpNewspaperRequest, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IFormulaCalculationResponse> => {
    
        const response = await http({
                method: 'POST',
                url: `${openApi.endpointUrl}/calculation/v1/calculate/green-grp/newspaper`,
                header: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    greenGrpOnlineAudio = async (body: IGreenGrpOnlineAudioRequest, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IFormulaCalculationResponse> => {
    
        const response = await http({
                method: 'POST',
                url: `${openApi.endpointUrl}/calculation/v1/calculate/green-grp/online-audio`,
                header: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    greenGrpOnlineImage = async (body: IGreenGrpOnlineImageRequest, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IFormulaCalculationResponse> => {
    
        const response = await http({
                method: 'POST',
                url: `${openApi.endpointUrl}/calculation/v1/calculate/green-grp/online-image`,
                header: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    greenGrpOnlineSearch = async (body: IGreenGrpOnlineSearchRequest, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IFormulaCalculationResponse> => {
    
        const response = await http({
                method: 'POST',
                url: `${openApi.endpointUrl}/calculation/v1/calculate/green-grp/online-search`,
                header: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    greenGrpOnlineVideo = async (body: IGreenGrpOnlineVideoRequest, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IFormulaCalculationResponse> => {
    
        const response = await http({
                method: 'POST',
                url: `${openApi.endpointUrl}/calculation/v1/calculate/green-grp/online-video`,
                header: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    greenGrpOOH = async (body: IGreenGrpOOHRequest, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IFormulaCalculationResponse> => {
    
        const response = await http({
                method: 'POST',
                url: `${openApi.endpointUrl}/calculation/v1/calculate/green-grp/ooh`,
                header: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    greenGrpRadio = async (body: IGreenGrpRadioRequest, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IFormulaCalculationResponse> => {
    
        const response = await http({
                method: 'POST',
                url: `${openApi.endpointUrl}/calculation/v1/calculate/green-grp/radio`,
                header: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    greenGrpSocialMediaOnlineImage = async (body: IGreenGrpSocialMediaOnlineImageRequest, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IFormulaCalculationResponse> => {
    
        const response = await http({
                method: 'POST',
                url: `${openApi.endpointUrl}/calculation/v1/calculate/green-grp/social-media-online-image`,
                header: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    greenGrpSocialMediaOnlineVideo = async (body: IGreenGrpSocialMediaOnlineVideoRequest, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IFormulaCalculationResponse> => {
    
        const response = await http({
                method: 'POST',
                url: `${openApi.endpointUrl}/calculation/v1/calculate/green-grp/social-media-online-video`,
                header: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    greenGrpSupplement = async (body: IGreenGrpSupplementRequest, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IFormulaCalculationResponse> => {
    
        const response = await http({
                method: 'POST',
                url: `${openApi.endpointUrl}/calculation/v1/calculate/green-grp/supplement`,
                header: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    greenGrpTotalWeight = async (body: IGreenGrpPrintTotalWeightRequest, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IFormulaCalculationResponse> => {
    
        const response = await http({
                method: 'POST',
                url: `${openApi.endpointUrl}/calculation/v1/calculate/green-grp/print-total-weight`,
                header: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    hotelStayTravel = async (body: IHotelStayRequest, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IFormulaCalculationResponse> => {
    
        const response = await http({
                method: 'POST',
                url: `${openApi.endpointUrl}/calculation/v1/calculate/travel/hotel-stay`,
                header: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    pppMaterialWeight = async (body: IPPPMaterialWeightRequest, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IFormulaCalculationResponse> => {
    
        const response = await http({
                method: 'POST',
                url: `${openApi.endpointUrl}/calculation/v1/calculate/ppp/weight`,
                header: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    pppMaterialWeightBatch = async (body: IPPPMaterialWeightBatchRequest, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IPPPMaterialWeightBatchResponse> => {
    
        const response = await http({
                method: 'POST',
                url: `${openApi.endpointUrl}/calculation/v1/calculate/ppp/weight/batch`,
                header: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    pppPaperDimension = async (body: IPPPPaperDimensionRequest, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IFormulaCalculationResponse> => {
    
        const response = await http({
                method: 'POST',
                url: `${openApi.endpointUrl}/calculation/v1/calculate/ppp/dimension`,
                header: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    railTravel = async (body: IRailTravelRequest, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IFormulaCalculationResponse> => {
    
        const response = await http({
                method: 'POST',
                url: `${openApi.endpointUrl}/calculation/v1/calculate/travel/rail`,
                header: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    roadTravel = async (body: IRoadTravelRequest, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IFormulaCalculationResponse> => {
    
        const response = await http({
                method: 'POST',
                url: `${openApi.endpointUrl}/calculation/v1/calculate/travel/road`,
                header: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    rothoCalculation = async (body: IRothoCalculationRequest, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IRothoCalculationResponse> => {
    
        const response = await http({
                method: 'POST',
                url: `${openApi.endpointUrl}/calculation/v1/calculate/pcf-rotho`,
                header: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    transportTotalEmissions = async (body: ICalculationRequest, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<ICalculationResponse> => {
    
        const response = await http({
                method: 'POST',
                url: `${openApi.endpointUrl}/calculation/v1/calculate/transportTotalEmissions`,
                header: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    vehicleFleetConsumption = async (body: IVehicleFleetConsumptionRequest, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IFormulaCalculationResponse> => {
    
        const response = await http({
                method: 'POST',
                url: `${openApi.endpointUrl}/calculation/v1/calculate/vehicle-fleet/consumption`,
                header: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    vehicleFleetDistance = async (body: IVehicleFleetDistanceRequest, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IFormulaCalculationResponse> => {
    
        const response = await http({
                method: 'POST',
                url: `${openApi.endpointUrl}/calculation/v1/calculate/vehicle-fleet/distance`,
                header: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    wasteManagement = async (body: IWasteManagementRequest, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IFormulaCalculationResponse> => {
    
        const response = await http({
                method: 'POST',
                url: `${openApi.endpointUrl}/calculation/v1/calculate/waste-management`,
                header: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

}
